/**
 * SPA origin embedded in Cognito Hosted UI authorize + OAuth token redirect_uri.
 * Must exactly match one of the user pool client's "Allowed callback URLs"
 * (scheme + host + port + path `/auth/callback`).
 *
 * Local dev pitfalls:
 * - `http://localhost:3000` and `http://127.0.0.1:3000` differ; omitting either in Cognito → `invalid_grant`.
 *
 * Pin to a single canonical host with:
 * REACT_APP_OAUTH_REDIRECT_ORIGIN=http://localhost:3000
 */
export function getOAuthRedirectOrigin() {
  try {
    if (typeof window === 'undefined') return '';
    const raw =
      typeof process !== 'undefined' &&
      process.env &&
      typeof process.env.REACT_APP_OAUTH_REDIRECT_ORIGIN === 'string'
        ? process.env.REACT_APP_OAUTH_REDIRECT_ORIGIN.trim()
        : '';
    const trimmed = raw.replace(/\/+$/, '');
    if (trimmed) {
      const u = new URL(trimmed);
      if (u.protocol !== 'http:' && u.protocol !== 'https:') {
        return window.location.origin;
      }
      return `${u.protocol}//${u.host}`;
    }
  } catch {}
  try {
    if (typeof window !== 'undefined') return window.location.origin;
  } catch {}
  return '';
}

export function getOAuthRedirectUri() {
  const o = getOAuthRedirectOrigin();
  return o ? `${o}/auth/callback` : '/auth/callback';
}
